export default __webpack_public_path__ + "static/media/65-Mobilia50thBirthdayCampaign.108cb2d5.jpg";